/**
 * @generated SignedSource<<f95f6526d7cafba2d06188202a019f4f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceRoutineTemplateListItemContent_routine$data = {
  readonly description: string | null;
  readonly descriptionFiles: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"ListItemDescriptionContentFiles_files">;
  }>;
  readonly descriptionImages: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"ListItemDescriptionContent_images">;
  }>;
  readonly title: string;
  readonly " $fragmentType": "WorkspaceRoutineTemplateListItemContent_routine";
};
export type WorkspaceRoutineTemplateListItemContent_routine$key = {
  readonly " $data"?: WorkspaceRoutineTemplateListItemContent_routine$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRoutineTemplateListItemContent_routine">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceRoutineTemplateListItemContent_routine",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "descriptionImages",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ListItemDescriptionContent_images"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "descriptionFiles",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ListItemDescriptionContentFiles_files"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Routine",
  "abstractKey": null
};

(node as any).hash = "c1b6a49d4c7d3ff175ea31c97b139e0c";

export default node;
